import { SET_PAYMENT_METHOD } from "../action.js";

export const setPaymentMethod = (paymentMethod) => {
  return (dispatch) => {
    dispatch({ type: SET_PAYMENT_METHOD, payload: paymentMethod });
  };
};
